module.exports = __webpack_public_path__ + "static/media/Niveau_elN1_4_485032.0113336f.png";